import View from '@/components/navTab/view.vue'
// 根据注册时间切换新旧素材空间（简化版）
// 固定阈值：2026-03-01 00:00:00（本地时区）

const Layout = () => import(/* webpackChunkName: "supplier" */ `@supplier/Layout.vue`)
const Index = () => import(/* webpackChunkName: "supplier" */ `@supplier/home/index.vue`)
const DistributorMine = () => import(/* webpackChunkName: "supplier" */ `@supplier/distributor/mine/index.vue`)
const DistributionRules = () => import(/* webpackChunkName: "supplier" */ `@supplier/distributor/rules/index.vue`)
const DistributionPriceControl = () => import(/* webpackChunkName: "supplier" */ `@supplier/distributor/priceControl/index.vue`)
const DistributionFreight = () => import(/* webpackChunkName: "supplier" */ `@supplier/distributor/freight/index.vue`)
const DistributorInvitation = () => import(/* webpackChunkName: "supplier" */ `@supplier/distributor/invitation/index.vue`)
const DistributionPrice = () => import(/* webpackChunkName: "supplier" */ `@supplier/distributor/price/index.vue`)
const UserManage = () => import(/* webpackChunkName: "supplier" */ `@supplier/base/UserManage.vue`)
const ContactManage = () => import(/* webpackChunkName: "supplier" */ `@supplier/base/ContactManage.vue`)
const ShopManage = () => import(/* webpackChunkName: "supplier" */ `@supplier/base/ShopManage.vue`)
const PlatformConf = () => import(/* webpackChunkName: "supplier" */ `@supplier/prod/conf/index.vue`)
const ProdCenter = () => import(/* webpackChunkName: "supplier" */ `@supplier/prod/center/index.vue`)
const ProdLog  = () => import(/* webpackChunkName: "supplier" */`@supplier/prod/log/index.vue`)
const AutoDistributionRule  = () => import(/* webpackChunkName: "supplier" */`@supplier/prod/autoDistributionRule/index.vue`)

const GoodsFissionRule  = () => import(/* webpackChunkName: "distributor" */`@distributor/prod/goodsFissionRule/index.vue`)
const AIImageUpdate  = () => import(/* webpackChunkName: "distributor" */`@distributor/prod/AIImageUpdate/index.vue`)
const ProdRelationship = () => import(/* webpackChunkName: "supplier" */`@distributor/prod/relationship/index.vue`)
const PictureZone = () => import(/* webpackChunkName: "supplier" */`@supplier/prod/picTureZone/index.vue`)
const NewPictureZone = () => import(/* webpackChunkName: "supplier" */`@supplier/prod/newPicTureZone/index.vue`)
const myShop = () => import(/* webpackChunkName: "supplier" */`@supplier/commodity/myShop.vue`)
const shopItemDetail = () => import(/* webpackChunkName: "supplier" */`@supplier/commodity/shopItemDetail/index.vue`)
const Shipment = () => import(/* webpackChunkName: "supplier" */`@supplier/dangkou/shipment/index.vue`)
const TaskCenter = () => import(/* webpackChunkName: "distributor" */`@/pages/taskCenter/index.vue`)

const AddressBook = () => import(/* webpackChunkName: "distributor" */`@distributor/cooperation/addressBook/index.vue`)
import DownloadCenter from '../../pages/distributor/trade/downloadCenter/index.vue';

const name = (routerName) => `s_${routerName}`;

// 路由层按需解析组件，避免在此文件引入 store 造成循环依赖
const resolvePictureZoneComponent = () => {
  // let companyCreated = 0;
  // try {
  //   const raw = window.localStorage.getItem('userinfo');
  //   if (raw) {
  //     const u = JSON.parse(raw);
  //     companyCreated = Number(u && u.companyCreated) || 0;
  //   }
  // } catch (e) {}
  // const START_TS = new Date(2026, 2, 1, 0, 0, 0).getTime(); // 2026-03-01 00:00:00
  // return companyCreated >= START_TS ? NewPictureZone() : PictureZone();
  return NewPictureZone();
}

const routes = [
  {
    path: '/supplier',
    component: Layout,
    redirect: '/supplier/index',
    name: 'supplier',
    children: [
      {
        name: name('index'),
        path: 'index',
        component: Index,
        meta: {
          title: '首页',
          icon: 'el-icon-shouye1'
        }
      },
      {
        name: name('DistributorManagement'),
        path: 'management',
        component: View,
        redirect: '/distributor/mine',
        meta: {
          title: '分销商管理',
          icon: 'el-icon-fenxiaoshangguanli'
        },
        children: [
          {
            name: name('DistributorMine'),
            path: 'mine',
            component: DistributorMine,
            meta: {
              title: '我的分销商'
            }
          },
          {
            name: name('DistributorInvitation'),
            path: 'invitation',
            component: DistributorInvitation,
            meta: {
              title: '邀请分销商'
            }
          },
          {
            name: name('DistributionPrice'),
            path: 'price',
            component: DistributionPrice,
            meta: {
              title: '分销价管理'
            }
          },
          {
            name: name('DistributionRules'),
            path: 'rules',
            component: DistributionRules,
            meta: {
              title: '分销商品规则'
            }
          },
          {
            name: name('DistributionFreight'),
            path: 'freight',
            // component: DistributionFreight,
            meta: {
              title: '运费规则管理',
            }
          },
          {
            name: name('DistributionPriceControl'),
            path: 'priceControl',
            component: DistributionPriceControl,
            meta: {
              title: '商品控价管理'
            }
          },
        ]
      },
      {
        path: 'prod',
        name: name('SupplierProd'),
        component: View,
        meta: {
          title: '商品管理',
          icon: 'el-icon-shangpinguanli'
        },
        children: [
          {
            path: 'center',
            name: name("prod_center"),
            component: ProdCenter,
            meta: {
              title: '商品中心'
            }
          },
          {
            path: '/supplier/prod_conf',
            name: name('SupplierProdConf'),
            component: PlatformConf,
            meta: {
              title: '商品平台配置'
            }
          },
          {
            path: 'log',
            name: name("prod_log"),
            component: ProdLog,
            meta: {
              title: '商品日志'
            }
          },
          {
            path:'/supplier/prod_relationship',
            name: name('Relationship'),
            component: ProdRelationship,
            meta: {
              title: '供分销商品关系',
              withoutLeftNav: true,
              showWithPath: '/supplier/prod',
            }
          },
          {
            path: 'picture_zone',
            name: name("prod_picture_zone"),
            component: resolvePictureZoneComponent,
            meta: {
              title: '商品素材空间'
            }
          },
          {
            path: 'auto_distribution_rule',
            name: name("prod_auto_distribution_rule"),
            component: AutoDistributionRule,
            meta: {
              title: '自动铺货规则'
            }
          },
          {
            path: 'goods_fission_rule',
            name: name("prod_goods_fission_rule"),
            component: GoodsFissionRule,
            meta: {
              title: 'AI爆款裂变'
            }
          },{
            path:'ai_image_updaete',
            name: name("prod_ai_image_updaete"),
            component: AIImageUpdate,
            meta: {
              title: 'AI改图'
            }
          },
          {
            path: 'taskCenter',
            name: name("task_center"),
            component: TaskCenter,
            meta: {
              title: '任务中心'
            }
          },
        ]
      },
      {
        path: '/supplier/commodity',
        name: name('commodity'),
        redirect: 'supplier/commodity/myShop',
        component: View,
        meta: {
          title: '我要供货',
          icon: 'el-icon-s-shop'
        },
        children: [
          {
            name: name('myShop'),
            path: 'myShop',
            component: myShop,
            meta: {
              title: '我的小店'
            }
          },
          {
            name: name('myShopItemDetail'),
            path: 'myShop/detail/:id',
            component: shopItemDetail,
            meta: {
              title: '商品详情',
              showWithPath: '/supplier/commodity/myShop',
              withoutLeftNav: true
            }
          }
        ]
      },
      {
        path: '/supplier/dangkou',
        name: name('dangkou'),
        redirect: 'supplier/dangkou/shipment',
        component: View,
        meta: {
          title: '档口拿货',
          icon: 'el-icon-date'
        },
        children: [
          {
            name: name('shipment'),
            path: 'shipment',
            component: Shipment,
            meta: {
              title: '待出货'
            }
          },
          // {
          //   name: name('shipmentItemDetail'),
          //   path: 'shipment/detail/:distributorCompanyId',
          //   component: ShipmentDetail,
          //   meta: {
          //     title: '待出货明细',
          //     showWithPath: '/supplier/dangkou/shipment',
          //     withoutLeftNav: true
          //   }
          // }
        ]
      },
      {
        path: '/supplier/base',
        name: name('base'),
        redirect: '/supplier/base/shop',
        component: View,
        meta: {
          title: '基础管理',
          icon: 'el-icon-jichuguanli'
        },
        children: [
          {
            name: name('SupplierUser'),
            path: 'user',
            component: UserManage,
            meta: {
              title: '用户管理'
            }
          },
          {
            name: name('SupplierContact'),
            path: 'contact',
            component: ContactManage,
            meta: {
              title: '负责人信息管理'
            }
          },
          {
            name: name('DistributorAddress'),
            path: 'address',
            component: AddressBook,
            meta: {
              title: '地址管理'
            }
          }
        ]
        
      },
      {
        name: name('DistributorShop'),
        path: '/supplier/shopManage',
        // component: ShopManage,
        meta: {
          title: '店铺管理',
          icon: 'el-icon-dianpuzhanghaoguanli'
        }
      },
      {
        path: 'download_center',
        name: name('DownloadCenter'),
        component: DownloadCenter,
        meta: {
          title: '下载中心',
          icon: 'el-icon-download'
        },
        hide: true,
      },
      // erp 任务中心
      {
        path: 'erp_task_center',
        name: name('erpTaskCenter'),
        component: () => import('@/pages/common/ErpTaskCenter.vue'),
        meta: {
          title: '任务中心',
        },
        hide: true,
      }
    ]
  }
]

// 开发环境将测试模块加进去
if (process.env.NODE_ENV === 'development') {
  routes[0].children.push({
    name: name('test'),
    path: 'test',
    component: View,
    meta: {
      title: '测试模块',
      icon: 'el-icon-menu'
    },
    children: [{
      name: name('t1'),
      path: 't1',
      component: () => import(/* webpackChunkName: "distributor" */ `@distributor/test/test1/index.vue`),
      meta: {
        title: 't1'
      }
    }, {
      name: name('t2'),
      path: 't2',
      component: () => import(/* webpackChunkName: "distributor" */ `@distributor/test/test2/index.vue`),
      meta: {
        title: 't2'
      }
    }]
  },)
}

function completionPath(item, parentItem) {
  if (parentItem && item.path && item.path[0] !== '/') {
    item.path = parentItem.path + '/' + item.path
  }

  if (item.children && item.children.length > 0) {
    item.children.forEach(i => {
      completionPath(i, item)
    })
  }
}

routes.forEach(item => {
  completionPath(item)
})

export default routes
